import {
  BULK_GUSTO_INVITE,
  DELETE_GUSTO_INTEGRATION,
  ENABLE_INTEGRATION_WORKFLOW,
  GET_ALL_INTEGRATIONS_LIST,
  GET_ENABLED_INTEGRATIONS_LIST,
  GET_GUSTO_COMPANY_DETAILS,
  GET_GUSTO_EMPLOYEE_LIST,
  GET_INTEGRATIONS_FEATURES,
  GET_INTEGRATION_ENABLED_WORKFLOWS_LIST,
  GET_INTEGRATION_WORKFLOWS_LIST,
  RUN_INTEGRATION_WORKFLOW,
  UPDATE_GUSTO_COMPANY_LOGO,
  UPDATE_INTEGRATIONS_FEATURES,
} from '../../modules/constants';

export function getIntegrationsFeatures(payload) {
  return {
    type: GET_INTEGRATIONS_FEATURES,
    payload,
  };
}

export function updateIntegrationsFeatures(payload) {
  return {
    type: UPDATE_INTEGRATIONS_FEATURES,
    payload,
  };
}

export function getAllIntegrationsList(payload) {
  return {
    type: GET_ALL_INTEGRATIONS_LIST,
    payload,
  };
}

export function getIntegrationWorkflowsList(payload) {
  return {
    type: GET_INTEGRATION_WORKFLOWS_LIST,
    payload,
  };
}

export function getEnabledIntegrationsList(payload) {
  return {
    type: GET_ENABLED_INTEGRATIONS_LIST,
    payload,
  };
}

export function getIntegrationEnabledWorkflowsList(payload) {
  return {
    type: GET_INTEGRATION_ENABLED_WORKFLOWS_LIST,
    payload,
  };
}

export function enableIntegrationWorkflow(payload) {
  return {
    type: ENABLE_INTEGRATION_WORKFLOW,
    payload,
  };
}

export function runIntegrationWorkflow(payload) {
  return {
    type: RUN_INTEGRATION_WORKFLOW,
    payload,
  };
}


// Gusto Integration Actions
export function getGustoCompanyDetails(payload) {
  return {
    type: GET_GUSTO_COMPANY_DETAILS,
    payload,
  };
}

export function getGustoEmployeeList(payload) {
  return {
    type: GET_GUSTO_EMPLOYEE_LIST,
    payload,
  };
}

export function updateGustoCompanyLogo(payload) {
  return {
    type: UPDATE_GUSTO_COMPANY_LOGO,
    payload,
  };
}

export function deleteGustoIntegration(payload) {
  return {
    type: DELETE_GUSTO_INTEGRATION,
    payload,
  };
}

export function bulkGustoInvite(payload) {
  return {
    type: BULK_GUSTO_INVITE,
    payload,
  };
}